import { detailFieldStyles } from '@v2/components';

export const styles = {
  fieldContainer: detailFieldStyles.fieldContainer,
  actionsContainer: 'tw-mt-6 tw-pt-4 tw-border-t tw-border-neutral-100',
};
